import React from 'react';
import PropTypes from 'prop-types';
import './listing-status.scss';
import Tooltip from '../tooltip/tooltip';

export default function StaticListingStatus({
  statusLabel,
  autoWidth,
  className,
  labelTooltip,
  textClass,
  tooltipClass,
}) {
  return (
    statusLabel !== '' && (
      <Tooltip className={tooltipClass} content={labelTooltip || statusLabel}>
        <span className={`status${autoWidth ? ' w-auto' : ''} ${className}`}>
          <span className={`txt ${textClass}`}>{statusLabel}</span>
        </span>
      </Tooltip>
    )
  );
}

StaticListingStatus.propTypes = {
  statusLabel: PropTypes.string,
  autoWidth: PropTypes.bool,
  className: PropTypes.string,
  labelTooltip: PropTypes.string,
  textClass: PropTypes.string,
  tooltipClass: PropTypes.string,
};

StaticListingStatus.defaultProps = {
  statusLabel: '',
  autoWidth: false,
  className: '',
  labelTooltip: '',
  textClass: '',
  tooltipClass: '',
};
